import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CameraService } from '@services/camera.service';
@Component({
  selector: 'gc-picture',
  templateUrl: './picture.component.html',
  styleUrls: ['./picture.component.scss'],
  standalone: false,
})
export class PictureComponent {
  @Input() picture: string;
  @Input() addLabel: string;
  @Input() editLabel: string;
  @Input() key: string;
  @Input() providedCamera?: string;
  @Input() upload?: boolean;
  @Input() disable?: boolean;
  @Output() pictureChanged = new EventEmitter<string>();

  constructor(
    private readonly camera: CameraService,
    private readonly translateService: TranslateService,
  ) {}

  get addPictureLabel() {
    return this.addLabel ?? this.translateService.instant('add_picture');
  }

  get editPictureLabel() {
    return this.editLabel ?? this.translateService.instant('edit_picture');
  }

  updatePicture() {
    if (this.disable) {
      return;
    }
    this.camera.openCamera(this.picture, this.providedCamera, this.upload).subscribe((i) => {
      if (i || i === null) {
        this.pictureChanged.emit(i);
      }
    });
  }
}
